import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableRecentFBPosts = Loadable({
  loader: function loader() {
    return import('../RecentFBPosts.jsx');
  },
  loading: ComponentLoading
});
export default LoadableRecentFBPosts;